<template>
    <div class="help-list">
      <!-- 返回按钮 -->
      <div class="back-icon">
        <img class="back1"  @click="$router.back()"  src="../images/fanhui1.png" mode="heightFix" alt="">
      </div>
      
      <!-- 列表部分 -->
      <div class="list-container">
        <!-- 常见问题板块 -->
        <div class="list-section" v-for="(otem,index) in nav_footer" :key="index" :style="index==nav_footer.length-1?'border: none':''">
          <div class="section-title">{{otem.name}}</div>
          <div class="list-item" v-for="(item, indexs) in otem.items" :key="indexs" @click="handleClick(item)">
            <span class="item-text">{{ item.name }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
  
        <!-- <div class="list-section">
          <div class="section-title">协议</div>
          <div class="list-item" v-for="(item, index) in agreements" :key="index" @click="handleClick(item)">
            <span class="item-text">{{ item.title }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
  
        <div class="list-section" style="border: none;">
          <div class="section-title">公司信息</div>
          <div class="list-item" v-for="(item, index) in companyInfo" :key="index" @click="handleClick(item)">
            <span class="item-text">{{ item.title }}</span>
            <van-icon name="arrow" />
          </div>
        </div> -->
      </div>
      <v-foot></v-foot>
    </div>
    
  </template>
  
  <script>
  export default {
    data() {
      return {
        commonQuestions: [
          { title: '退换货', path: '/return' },
          { title: '商品', path: '/products' }
        ],
        agreements: [
          { title: '回家试穿服务协议', path: '/try-on' },
          { title: '隐私协议', path: '/privacy' },
          { title: '运费险', path: '/shipping-insurance' },
          { title: '尺码推荐助手协议', path: '/size-guide' }
        ],
        companyInfo: [
          { title: '企业资质', path: '/qualification' },
          { title: '门店与服务', path: '/stores' },
          { title: '形象片', path: '/gallery' },
          { title: '关于品牌', path: '/about' }
        ],
        nav_footer: []
      }
      
    },
    created() {
    this.getNav()
    this.getjiant()
  },
    methods: {
      getjiant(){
        this.GET("api/agreement/maidian?type=questions", function (data) {
          if (data.code == 0) {
            console.log(data);
          }
        });
      },
        getNav() {
        var _self = this;
        this.GET("nav", function (data) {
          if (data.code == 0) {
            _self.nav_footer = data.data.footer;
          }
        });
      },
      handleClick(item) {
        this.$router.push({
          path:'/help',
					query:{id:item.value}
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .help-list {
    /* padding: 20px; */
    background: #fff;
  }
  
  .back-icon {
    padding: 10px 0;
    font-size: 40px;
    display: flex;
    justify-content: flex-start;
    margin-left: 25px;
    margin-bottom: 10px;
  }
  .back1{
    height: 26px;
  }
  .list-section {
    margin-bottom: 20px;
    padding: 0 8%;
    border-bottom: 1px solid #CCCCCC;
    padding-bottom: 20px;

  }
  
  .section-title {
    font-size: 18px;
    color: #333333;
    padding: 10px 0;
    text-align: left;
    font-weight: 700;
  }
  
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    /* border-bottom: 1px solid #f5f5f5; */
    color: #333;
  }
  
  .item-text {
    font-size: 14px;
  }
  
  .van-icon {
    color: #999;
    font-size: 14px;
  }
  
  /* 点击效果 */
  .list-item:active {
    background-color: #f9f9f9;
  }
  </style>